





















































































































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Document } from "@/model/document2/document";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";
// import { setInterval } from "timers";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import AlignControl from "../alignControl/alignControl.vue";

@Component({
  components: {
    ValueEdit,
    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    AlignControl
  }
})
export default class GroupPosition extends Vue 
{
    @Prop() private layer!: GroupLayer;

    // 裏面を持つか?
    private get hasReverse()
    {
        var document = this.$store.getters.document;
        return this.currentDocument.hasReverseSurface;
    }

    private get x() {
        return this.layer.x;
    }
    private get y() {
        return this.layer.y;
    }
    private get width() {
        return this.layer.width;
    }
    private get height() {
        return this.layer.height;
    }
    private get rotate() {
        return this.layer.rotate;
    }

    mounted() {
    }

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus() 
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい → storeから直接取ってくることになった
    openStatus = {
        opend: true
    };

    groupPositionContentsOpenAnimate = false;
    groupPositionContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.groupPositionContentsCloseAnimate = true;
            setTimeout(() => {
                this.openStatus.opend = false;
                this.groupPositionContentsOpenAnimate = false;
                this.groupPositionContentsCloseAnimate = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.groupPositionContentsOpenAnimate = true;
            setTimeout(() => {
                this.groupPositionContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    public changeLayerProperty(value: any, propertyName: string, isFinish) 
    {
        if (propertyName == "name") {
            // レイヤー名変更
            this.$emit("doCommand", "changeLayerProperty", {
                layer: this.layer,
                propertyName: propertyName,
                value: value
            });
        } else if (propertyName == "rotate") {
            // レイヤー回転
            this.$emit("doCommand", "rotateLayer", {
                layer: this.layer,
                rotate: value,
                isFinish: isFinish
            });
        } else if (propertyName == "x" || propertyName == "y") {
            // レイヤー移動
            var newX = propertyName == "x" ? value : this.layer.x;
            var newY = propertyName == "y" ? value : this.layer.y;
            this.$emit("doCommand", "moveLayer", {
                layer: this.layer,
                x: newX,
                y: newY,
                isFinish: isFinish
            });
        } 
        else if (propertyName == "width")
        {
            if(this.layer.width != 0)
            {
                this.$emit("doCommand", "resizeLayer", {
                    layer: this.layer,
                    width: value,
                    height: value * this.layer.height / this.layer.width,
                    isFinish: isFinish
                });
            }
        } 
        else if (propertyName == "height") 
        {
            if(this.layer.height != 0)
            {
                this.$emit("doCommand", "resizeLayer", {
                    layer: this.layer,
                    width: value * this.layer.width / this.layer.height,
                    height: value,
                    isFinish: isFinish
                });
            }
        }
    }

    private dupilicateLayerToSurface(isReverse : boolean)
    {
        // 面へレイヤー複製
        this.$emit("doCommand", "dupilicateLayerToSurface", { layer : this.layer, isReverse : isReverse });
    }

    private deleteLayer() {
        // レイヤー削除
        this.$emit("doCommand", "deleteLayer", { deleteLayer: this.layer });
    }

    // レイヤーの整列
    private align(direction: 'horizontal' | 'vertical', alignment: string)
    {
        if (direction === 'horizontal')
        {
            this.$emit("doCommand", "alignLayerHorizontal", { layer: this.layer, alignment });
        }
        else
        {
            this.$emit("doCommand", "alignLayerVertical", { layer: this.layer, alignment });
        }
    }

    private onChangingValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, true);
    }

    public get currentDocument(): Document {
        return this.$store.getters.document;
    }

    //configcolor
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
    
}
